import { Component, HostListener } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ForgotPasswordFields, generateForgotPasswordForm } from '../../../../routes/auth/forgot-psw/form.functions';
import { DividerModule } from 'primeng/divider';
import { RippleModule } from 'primeng/ripple';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule } from '@angular/forms';
import { BannerComponent } from '../../../components/banner/banner.component';
import { InlineInputControlComponent } from '../../../components/form/inline-input-control/inline-input-control.component';
import { RegisterDialogComponent } from '../register-dialog/register-dialog.component';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { DataService } from '../../../../core/providers/data/data.service';
import {
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables,
} from '../../../../graphql/generated/generated-types';
import { REQUEST_PASSWORD_RESET } from './forgotten-password.graphql';
import { take } from 'rxjs';
import {
  AuthSuccessDialogBody,
  AuthSuccessDialogComponent,
  AuthSuccessDialogType,
} from '../auth-success-dialog/auth-success-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { SelectedModificationService } from '../../../services/selected-modification.service';
import { VehicleType } from '../../add-vehicle-form/vehcle-type.interfaces';
import { VehicleTypeService } from '../../../services/vehicle-type.service';

@Component({
  selector: 'app-forgot-psw-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ButtonModule,
    CheckboxModule,
    RippleModule,
    DividerModule,
    BannerComponent,
    InlineInputControlComponent,
    LoginDialogComponent,
    RegisterDialogComponent,

  ],
  templateUrl: './forgot-psw-dialog.component.html',
  styleUrl: './../auth-dialog-pages.scss',
})
export class ForgotPswDialogComponent {
  @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    if (this.forgotPasswordForm.valid) {
      this.resetPassword();
    }
  }

  public forgotPasswordForm: UntypedFormGroup = generateForgotPasswordForm();
  public ForgotPasswordFields = ForgotPasswordFields;
  public submited = false;
  public loading = false;

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogService: DialogService,
    private dataService: DataService,
    private router: Router,
    private vehicleTypeService: VehicleTypeService
  ) { }

  resetPassword() {
    this.dataService
      .mutate<
        RequestPasswordResetMutation,
        RequestPasswordResetMutationVariables
      >(REQUEST_PASSWORD_RESET, {
        emailAddress: this.forgotPasswordForm.get(ForgotPasswordFields.Email)
          ?.value,
      })
      .pipe(take(1))
      .subscribe({
        next: (response: any) => { },
        error: (error: HttpErrorResponse) => {
          this.openAuthSuccessDialog();
        },
        complete: () => {
          this.openAuthSuccessDialog();
        },
      });
  }

  public openAuthSuccessDialog() {
    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(
      AuthSuccessDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
        data: {
          email: this.forgotPasswordForm.get(ForgotPasswordFields.Email)?.value,
          type: 'ForgotPassword' as AuthSuccessDialogType,
        } as AuthSuccessDialogBody,
      }
    );

    dialogRef.onClose.subscribe((result) => { });
  }
  public closeDialog() {
    this.dialogRef.close();
  }

  public openLoginDialog() {
    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(
      LoginDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      }
    );

    dialogRef.onClose.subscribe((result) => {
      if (result) {
               /*
        this.router.navigate(['/'], { queryParamsHandling: 'merge', skipLocationChange: true }).then(() => {
          this.router.navigate(['/' + (this.vehicleTypeService.currentVehicleType)], {
            queryParamsHandling: 'merge'
          });
        })
           */
      }
    });
  }

  public openRegisterDialog() {
    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(
      RegisterDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      }
    );

    dialogRef.onClose.subscribe((result) => { });
  }



}
